import QueryKeyFactory from "../../../api/hooks/utils/queryKeyFactory";

export const contractKeys = new QueryKeyFactory('contract')
export const billKeys = new QueryKeyFactory('bill')

